export const lightColors = {
  background1: '#FFFFFF',
  background2: '#FFFFFF',
  background3: '#FFFFFF',
  background4: '#F5F5F5',
  background5: '#F1BC11',
  background6: '#9E9E9E',
  heroInfo: '#F0F0F0',
  highlight: '#33A9DA',
  textPrimary: '#181818',
  textGreyPrimary: '#6B6B6B',
  textSecondary: '#000000',
  textTertiary: '#000000',
  textToggle: '#0093D1',
  textBold: '#000040',
  textBoldSecondary: '#0093D1',
  textCaption: '#000020',
  textCaptionSecondary: '#000000',
  textCard: '#CCCCD9',
  textLight: '#404040',
  textLight2: '#616161',
  primary: '#FFFFFF',
  secondary: '#E6F4FA',
  active: '#E6F4FA',
  red: '#E22134',
  green: '#30A65A',
  layer: '#152A59',
  button: '#0071FF',
  theme: '#131313',
  calendar: '#3057AE',
  greenLight: '#A9D3AB',
  gray10: '#181818',
  gray9: '#282828',
  gray8: '#333333',
  gray7: '#404040',
  gray6: '#616161',
  gray5: '#757575',
  gray4: '#9E9E9E',
  gray3: '#BDBDBD',
  gray2: '#D9D9D9',
  gray1: '#EEEEEE',
  gray0: '#F8F8F8',
  black: '#000000',
  title: '#181818',
  titleSecondary: 'rgba(0, 0, 0, 0.87)',
  subTitle: '#000000',
  bnbYellow: '#F1BC11',
  subtitleSecondary: ' #002C3F',
  tableBorder: '#000000',
  tableBackground: '#FFFFFF',
  affliateStep: '#FAFAFA',
  pricingCardBackground: '#FFFFFF',
  arrowColor: '#113366',
  popupText: '#888888',
  themeToggle: '#888888'
}

export const darkColors = {
  background1: '#181818',
  background2: '#000000',
  background3: '#282828',
  background4: '#282828',
  background5: '#333333',
  background6: '#F1BC11',
  heroInfo: '#282828',
  highlight: '#B3DFF1',
  textPrimary: '#FFFFFF',
  textSecondary: '#FFFFFF',
  textTertiary: '#F1BC11',
  textToggle: '#33A9DA',
  textLight: '#ffffff',
  textGreyPrimary: '#D3D3D3',
  textLight2: '#ffffff',
  textBold: '#FFFFFF',
  textBoldSecondary: '#66BEE3',
  textCaption: '#FFFFFF',
  textCaptionSecondary: '#FAFAFA',
  textCard: '#FFFFFF',
  primary: '#004A69',
  secondary: '#002C3F',
  active: '#006792',
  red: '#FF5B6B',
  green: '#39BA66',
  layer: '#152A59',
  button: '#0071FF',
  theme: '#131313',
  calendar: '#3057AE',
  greenLight: '#A9D3AB',
  gray10: '#181818',
  gray9: '#282828',
  gray8: '#333333',
  gray7: '#404040',
  gray6: '#616161',
  gray5: '#757575',
  gray4: '#9E9E9E',
  gray3: '#BDBDBD',
  gray2: '#D9D9D9',
  gray1: '#EEEEEE',
  gray0: '#F8F8F8',
  black: '#000000',
  title: '#FFFFFF',
  subTitle: '#FAFAFA',
  titleSecondary: '#FFFFFF',
  bnbYellow: '#F1BC11',
  subtitleSecondary: '#F1BC11',
  tableBorder: '#9E9E9E',
  affliateStep: '#757575',
  tableBackground: '#282828',
  pricingCardBackground: '#333333',
  arrowColor: '#F1BC11',
  popupText: '#FFFFFF',
  themeToggle: '#F1BC11'
}
